import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import I3NavBrand from './I3NavBrand';
import { BOOK_SESSION_PATH } from '../bookingConfig';
import '../styles/I3Layout.css';
import '../styles/I3BridgeButtons.css';
import '../styles/I3NavBrand.css';

const NAV_LINKS = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About' },
  { to: '/services', label: 'Services' },
  { to: '/blog', label: 'Journal' },
  { to: '/contact', label: 'Contact' },
] as const;

const I3Nav: React.FC = () => {
  const location = useLocation();
  const pathname = location.pathname;

  const navLinkClass = (to: string): string => {
    if (pathname === to) return 'active';
    const base = '/';
    if (to === base) return pathname === base || pathname === `${base}/` ? 'active' : '';
    return pathname.startsWith(`${to}/`) ? 'active' : '';
  };

  return (
    <nav className="i3-nav i3-nav--over-video" aria-label="Primary">
      <I3NavBrand />
      <ul className="i3-nav-links">
        {NAV_LINKS.map(({ to, label }) => (
          <li key={to}>
            <Link to={to} className={navLinkClass(to)}>
              {label}
            </Link>
          </li>
        ))}
      </ul>
      <Link
        to={BOOK_SESSION_PATH}
        className="i3-nav-book-cta i3-bridge-btn i3-bridge-btn--sand"
        aria-label="Book a Session"
      >
        <span className="i3-nav-book-cta-label i3-nav-book-cta-label--long">Book a Session</span>
        <span className="i3-nav-book-cta-label i3-nav-book-cta-label--short">Book</span>
      </Link>
    </nav>
  );
};

export default I3Nav;
